// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Radio_wrap__4rFaP","input":"Radio_input__ho-J3","radio":"Radio_radio__3kGUj","label":"Radio_label__fUp3u"};